import { api } from './api';
export const marketplaceApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 获取资产列表
        getAssets: builder.query({
            query: (filters) => ({
                url: '/marketplace/assets',
                params: filters,
            }),
            providesTags: ['Asset'],
        }),
        // 获取单个资产
        getAsset: builder.query({
            query: (id) => `/marketplace/assets/${id}`,
            providesTags: (result, error, id) => [{ type: 'Asset', id }],
        }),
        // 搜索资产
        searchAssets: builder.query({
            query: (query) => ({
                url: '/marketplace/search',
                params: { q: query },
            }),
            providesTags: ['Asset'],
        }),
        // 上传资产
        uploadAsset: builder.mutation({
            query: (formData) => ({
                url: '/marketplace/assets',
                method: 'POST',
                body: formData,
            }),
            invalidatesTags: ['Asset'],
        }),
        // 更新资产
        updateAsset: builder.mutation({
            query: ({ id, data }) => ({
                url: `/marketplace/assets/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Asset', id }, 'Asset'],
        }),
        // 删除资产
        deleteAsset: builder.mutation({
            query: (id) => ({
                url: `/marketplace/assets/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Asset'],
        }),
        // 收藏资产
        favoriteAsset: builder.mutation({
            query: (id) => ({
                url: `/marketplace/assets/${id}/favorite`,
                method: 'POST',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Asset', id }],
        }),
        // 取消收藏
        unfavoriteAsset: builder.mutation({
            query: (id) => ({
                url: `/marketplace/assets/${id}/favorite`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Asset', id }],
        }),
    }),
});
export const { useGetAssetsQuery, useGetAssetQuery, useSearchAssetsQuery, useUploadAssetMutation, useUpdateAssetMutation, useDeleteAssetMutation, useFavoriteAssetMutation, useUnfavoriteAssetMutation, } = marketplaceApi;
